import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IHallBooking } from "src/domain/entities"
import { hallBookingDeleteService } from "src/domain/services/hallBooking/hallBookingDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	hallBooking: IHallBooking
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const HallBookingDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	hallBooking,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleItemDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await hallBookingDeleteService({ id: hallBooking.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [hallBooking, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Hall Booking: ${hallBooking.reason}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleItemDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
